import { useTranslation } from "react-i18next";
import { UserCheck } from "lucide-react";
import { NeuInput, NeuSelect } from "../../components/neu/Neu";

// اختيار المستلم — يفلتر تلقائياً موظفي فرع الفاتورة أو يسمح بإدخال مندوب خارجي.
export const BillReceiverPicker = ({ employees = [], branchId, external, setExternal,
                                      userId, setUserId, name, setName, phone, setPhone }) => {
  const { t } = useTranslation();
  const filtered = employees.filter((u) => !branchId || (u.branch_ids || []).includes(branchId));
  const pick = (id) => {
    const emp = filtered.find((u) => u.id === id);
    setUserId(id);
    setName(emp ? (emp.name || emp.email) : "");
  };
  return (
    <div className="rounded-2xl border-2 border-blue-500/40 bg-blue-500/5 p-3"
         data-testid="approve-receiver-panel">
      <p className="label-xs mb-1 flex items-center gap-2 text-blue-700">
        <UserCheck className="h-4 w-4" /> {t("acct.bills.approve.receiver")} *
      </p>
      <p className="mb-2 text-[11px] text-muted-foreground">
        {external ? t("acct.bills.approve.receiverHint")
                  : t("acct.bills.pay.branchFilterHint")}
      </p>
      <label className="mb-2 flex items-center gap-2 text-xs font-bold">
        <input type="checkbox" data-testid="approve-external" checked={external}
               onChange={(e) => { setExternal(e.target.checked); setUserId(""); setName(""); }} />
        {t("acct.bills.approve.external")}
      </label>
      {external ? (
        <NeuInput data-testid="approve-receiver-name" value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder={t("acct.bills.approve.receiverPh")} />
      ) : (
        <NeuSelect data-testid="approve-receiver-user" value={userId}
                    onChange={(e) => pick(e.target.value)}>
          <option value="">-- {t("acct.bills.approve.pickReceiver")} --</option>
          {filtered.map((u) => (
            <option key={u.id} value={u.id}>
              👤 {u.name || u.email}{u.job_title ? ` — ${u.job_title}` : ""}
            </option>
          ))}
        </NeuSelect>
      )}
      <NeuInput className="mt-2" data-testid="approve-receiver-phone" dir="ltr" value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder={t("acct.bills.approve.receiverPhonePh")} />
    </div>
  );
};
